// extracted by mini-css-extract-plugin
var _1 = "UserProfileHeader-module__animateUploadProgressBarWidth--sCJSm";
var _2 = "UserProfileHeader-module__animatedBackground--Gzbua";
var _3 = "UserProfileHeader-module__badges--vvKPL";
var _4 = "UserProfileHeader-module__buttons--G_jAR";
var _5 = "UserProfileHeader-module__description--Fkqg4";
var _6 = "UserProfileHeader-module__desktopAvatarContainer--XKsuL";
var _7 = "UserProfileHeader-module__header--PPFoI";
var _8 = "UserProfileHeader-module__main--NEnZK";
var _9 = "UserProfileHeader-module__menuContainer--Dod81";
var _a = "UserProfileHeader-module__mobileAvatarContainer--Iy7tA";
var _b = "UserProfileHeader-module__name--gzzQC";
var _c = "UserProfileHeader-module__nameAndTitle--wDuHb";
var _d = "UserProfileHeader-module__profile--de5eN";
var _e = "UserProfileHeader-module__title--FeGa4";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "badges", _4 as "buttons", _5 as "description", _6 as "desktopAvatarContainer", _7 as "header", _8 as "main", _9 as "menuContainer", _a as "mobileAvatarContainer", _b as "name", _c as "nameAndTitle", _d as "profile", _e as "title" }
